import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { inventoriesSelector, getInventoriesAction } from '../../../store/inventory'
import { Button, Spin } from 'antd'
import { InventoriesTable, InventoriesFilterPanel } from '../InventoriesTable'
import { DEFAULT_INVENTORY_STATUSES, MAX_ROWS_EXPORT } from '../constants'
import { DownloadOutlined } from '@ant-design/icons'
import { mapCurrentStatus, mapEquipment, mapOperationType, mapTargetPlace } from '../InventoriesTable/InventoriesTable'
import { formatDateTime } from '../../../utils/date-format'
import { getUserProjects, viewUserAttrs } from '../../../utils/user-utils'
import { exportRowsToXlsx } from '../../../utils/export-xls'
import { userSelector } from '../../../store/session'

const InventoryRequestsTabView = () => {
  const dispatch = useDispatch()
  const { isFetching, pagination, inventories } = useSelector(inventoriesSelector)
  const { user } = useSelector(userSelector)

  const [page, setPage] = useState(1)

  const userProjects = getUserProjects(user)

  const [filters, setFilters] = useState({
    current_status: { $in: DEFAULT_INVENTORY_STATUSES },
    $or: [{ target_project: { id: { $in: userProjects } } }, { target_project: { id: { $null: true } } }],
  })

  const tablePagination = useMemo(
    () => ({
      current: page,
      pageSize: 10,
      total: pagination.total,
      onChange: setPage,
      showSizeChanger: false,
    }),
    [pagination, page]
  )

  const loadData = (params = filters, pagination = { page, pageSize: 10 }) =>
    dispatch(getInventoriesAction({ filters: params, pagination }))

  useEffect(() => setPage(pagination.page), [pagination])

  useEffect(() => loadData(), [filters, page])

  const buildPagination = (page = 1, size = 10) => ({ page, pageSize: size })

  const onSearch = useCallback((filter) => {
    setPage(1)
    setFilters(filter)
  }, [])

  const exportData = useCallback(async () => {
    const header = [
      [
        '№ п/п',
        'Оборудование',
        'Тип операции',
        'Текущий статус',
        'Дата создания',
        'Дата подтверждения',
        'Целевое местоположение',
        'Пользователь создавший',
        'Пользователь принявший',
        'Комментарий',
      ],
    ]

    let data = await loadData(filters, buildPagination(1, MAX_ROWS_EXPORT))

    let rows = data.payload.data?.map(({ id, attributes }) => [
      id,
      mapEquipment(attributes.equipment),
      mapOperationType(attributes.operation_type),
      mapCurrentStatus(attributes.current_status),
      formatDateTime(attributes.createdAt),
      formatDateTime(attributes.accept_date),
      mapTargetPlace(attributes),
      viewUserAttrs(attributes.create_user),
      viewUserAttrs(attributes.accept_user),
      attributes.comment,
    ])

    rows && exportRowsToXlsx(rows, header, 'Отчет_по_заявкам_инвентаризации.xlsx')
  }, [filters])

  const columns = [
    'id',
    'equipment',
    'operation_type',
    'current_status',
    'created_date',
    'accept_date',
    'target',
    'create_user',
    'accept_user',
    'comment',
    'acceptance_act',
    'operations',
  ]

  return (
    <Spin spinning={isFetching}>
      <div style={{ display: 'flex' }}>
        <InventoriesFilterPanel userProjects={userProjects} onSearch={onSearch} />
        <Button
          style={{ marginLeft: 15, marginTop: 30 }}
          type="dashed"
          icon={<DownloadOutlined />}
          onClick={exportData}
        >
          Выгрузить в XLS
        </Button>
      </div>
      <InventoriesTable
        columnNames={columns}
        pagination={tablePagination}
        dataSource={inventories}
        onRefresh={loadData}
      />
    </Spin>
  )
}

export default InventoryRequestsTabView
